module.exports = __webpack_public_path__ + "media/images/landing/ar/manage@2x-de5124ce15ebd7f12c5b6d5824fd2dcd.webp";